export const IS_SIDER_COLLAPSED_KEY = 'isSiderCollapsed'
